import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d7cd55e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dw-action-sequence-icon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "11",
    cy: "11",
    r: "11",
    fill: "#90CD9E"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "10.9965",
    cy: "10.9999",
    r: "9.35",
    fill: "#25943F"
  })
], -1))
const _hoisted_3 = { class: "dw-action-sequence-icon__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.actionSequence), 1)
  ]))
}